import React, { FC } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";

import style from "./StepHeading.module.scss";

interface StepHeadingProps {
  step: number;
}

const StepHeading: FC<StepHeadingProps> = ({ step }) => {
  return (
    <>
      <h1 className={style.title}>
        <FormattedHTMLMessage id="selectionGuide.step.title" values={{ step }} />
      </h1>
      <p className={style.description}>
        <FormattedMessage id={`selectionGuide.step${step}.description`} />
      </p>
    </>
  );
};

export default StepHeading;
